module.exports = __webpack_public_path__ + "img/icon-pain-1.82198c36.png";